import React from "react";
import {
  SearchInputComponent,
} from "../../../../common/components";
import { LeadFilterProps } from "./lead-capture-filter.props";
import "./lead-capture-filter.scss";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import MODULES from "../../../../constants/modules";
import Button from "../../../../common/components/button/button";
import RefreshIcon from '@mui/icons-material/Refresh';

const LeadCaptureFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {

    onSearch,
    searchRef,
    isResetSearch,
    handleClickCreateNewForm,
    fetchData,
  } = props;
  const { canWrite } = useResourcePermissions(
    MODULES.VIEW_SURVEYS
  );
  const handleRefresh = () => {
    fetchData?.();
  };
  return (
    <div className="lead-capture-search-filter-wrapper">
      <div className="lead-capture-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Form Name,Created By"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-capture-filter-wrapper">
        <div className="lead-capture-refresh-icon survey-refresh-icon" onClick={handleRefresh} tabIndex={0} title="Refresh">
          <RefreshIcon sx={{ color: "action.active" }} />
        </div>
        {canWrite && (
          <div className="lead-capture-create-filter">
            <Button
            label="Create New Form"
            onClick={handleClickCreateNewForm}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadCaptureFilter;
